import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { scrollToElement } from '../utils/scrollToElement';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-24 pb-12 overflow-hidden" data-id="element-77">
      <div className="max-w-7xl mx-auto px-6 md:px-12 w-full grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center" data-id="element-78">
        <div className="order-2 lg:order-1 flex flex-col items-start z-10" data-id="element-79">
          <FadeIn data-id="element-80">
            <span className="uppercase tracking-[0.2em] text-xs text-ink-light mb-6 block" data-id="element-81">
              Un nuevo capítulo en el bienestar femenino
            </span>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-82">
            <h1 className="font-serif text-4xl sm:text-5xl md:text-7xl leading-[1.1] text-ink mb-6 md:mb-8" data-id="element-83">
              Recupera tu <em className="italic text-sand-dark" data-id="element-84">energía</em>,
              balance y <em className="italic text-sand-dark" data-id="element-85">claridad</em>.
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-86">
            <p className="text-base md:text-xl text-ink-light font-light leading-relaxed mb-8 md:mb-10 max-w-md" data-id="element-87">
              El método del 1% respaldado por la ciencia para equilibrar tus
              hormonas de forma natural, sin dietas extremas ni agotamiento.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="flex flex-col sm:flex-row items-center gap-6" data-id="element-88">
            <Button onClick={() => scrollToElement('precio')} data-id="element-89">
              Acceso Inmediato
            </Button>
            <a href="#method" className="text-sm uppercase tracking-widest text-ink-light hover:text-ink transition-colors border-b border-transparent hover:border-ink pb-1" data-id="element-90">
              Descubre el Método
            </a>
          </FadeIn>
        </div>

        <div className="order-1 lg:order-2 relative h-[40vh] sm:h-[50vh] lg:h-[80vh] w-full" data-id="element-91">
          <FadeIn delay={0.2} className="w-full h-full" data-id="element-92">
            <div className="absolute inset-0 bg-sage/20 rounded-t-full lg:rounded-t-[200px] lg:rounded-b-none transform -rotate-3 scale-105" data-id="element-93"></div>
            <img src="https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=80&w=2000&auto=format&fit=crop" alt="Mujer radiante con la luz del sol reflejándose en su rostro" className="relative w-full h-full object-cover rounded-t-full lg:rounded-t-[200px] lg:rounded-b-none shadow-soft-lg" data-id="element-94" />
          </FadeIn>
        </div>
      </div>
    </section>;
}